import { createSelector } from '@reduxjs/toolkit';

import { LinkData } from 'src/containers/ProjectDiagram/types/model';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';

export const projectLinkDataMatchSelector = (
  projectId: string,
  match: Partial<LinkData>
) =>
  createSelector(projectLinkDataArraySelector(projectId), (linkData) =>
    linkData.filter((data) =>
      Object.entries(match).every(
        ([key, value]) => value === data?.[key as keyof LinkData]
      )
    )
  );
